import "./styles.css";

import { MuseumShell } from "./shell";

const root = document.querySelector<HTMLElement>("#app");
if (root === null) throw new Error("UI_ELEMENT_MISSING: #app");

const shell = new MuseumShell(root);
void shell.start();
